
import knowledgeService from '@/services/knowledgeService';
import stores from '@/services/stores';

export default {
  data() {
    return {
      loading: false,
      filter: '',
      pagination: { page: 1, rowsPerPage: 6 },
      rows: [],
      totalFiles: 0,
      showViewDialog: false,
      selectedRow: null,
      showDeleteDialog: false,
      rowToDelete: null,
      inactiveSources: [
        { label: 'POS', count: "-" },
        { label: 'Sensors', count: "-" },
        { label: 'Links', count: 0 },
        { label: 'Files', count: 0 }
      ]
    };
  },
  computed: {
    columns() {
      return [
        {
          name: 'fileName',
          label: this.$store.state.user.translate.file_name,
          field: 'fileName',
          align: 'left'
        },
        {
          name: 'addedByName',
          label: this.$store.state.user.translate.added_by,
          field: 'addedByName',
          align: 'left'
        },
        {
          name: 'cDate',
          label: this.$store.state.user.translate.date_added,
          field: row =>
            row.cDate ? `${row.cDate.date} ${row.cDate.time}` : '',
          align: 'left'
        },
        {
          name: 'status',
          label: this.$store.state.user.translate.connection_status,
          field: 'statusIndex',
          align: 'left'
        },
        {
          name: 'actions',
          label: this.$store.state.user.translate.actions,
          field: 'actions',
          align: 'left'
        }
      ];
    },
    pagesNumber() {
      return Math.ceil(this.totalFiles / this.pagination.rowsPerPage);
    },
    pdfCount() {
      if (!Array.isArray(this.rows)) return 0;
      return this.rows.filter(f => f?.fileName?.toLowerCase().endsWith('.pdf'))
        .length;
    }

    // pdfCount() {
    //   if (!Array.isArray(this.rows)) return 0;
    //   const unique = new Set(
    //     this.rows
    //       .filter(f => f?.fileName?.toLowerCase().endsWith('.pdf'))
    //       .map(f => f.fileName)
    //   );
    //   return unique.size;
    // }
  },
  mounted() {
    this.fetchFiles();
  },
  methods: {
    statusLabel(index) {
      switch (index) {
        case 0:
          return this.$store.state.user.translate.in_progress || 'In Progress';
        case 1:
          return this.$store.state.user.translate.indexed || 'Indexed';
        case 2:
          return this.$store.state.user.translate.failed || 'Failed';
        case 3:
          return this.$store.state.user.translate.no_text || 'No Text';
        default:
          return 'Unknown';
      }
    },
    statusColor(index) {
      switch (index) {
        case 0:
          return 'blue';
        case 1:
          return 'green';
        case 2:
          return 'red';
        case 3:
          return 'grey';
        default:
          return 'grey';
      }
    },
    onSearchChange() {
      this.pagination.page = 1;
      this.fetchFiles();
    },
    async fetchFiles() {
      this.loading = true;
      try {
        let response;
        if (this.filter) {
          response = await knowledgeService.searchKnowledgeFiles({
            search: this.filter,
            page: this.pagination.page,
            rowsPerPage: this.pagination.rowsPerPage
          });
        } else {
          response = await knowledgeService.getAllKnowledgeFiles({
            page: this.pagination.page,
            rowsPerPage: this.pagination.rowsPerPage
          });
        }

        this.rows = response.items || [];
        this.totalFiles = response.total || this.rows.length;
      } catch (err) {
        console.error(err);
        this.$q.notify({ message: 'Failed to fetch files', color: 'red' });
      } finally {
        this.loading = false;
      }
    },
    async handleFiles(event) {
      const files = Array.from(event.target.files);

      for (const file of files) {
        if (file.type !== 'application/pdf') {
          this.$q.notify({
            message: `${file.name} is not a PDF`,
            color: 'red'
          });
          continue;
        }
        if (file.size > 25 * 1024 * 1024) {
          this.$q.notify({
            message: `${file.name} exceeds 25 MB limit`,
            color: 'red'
          });
          continue;
        }

        // 1️⃣ Add temporary row with "In Progress"
        const tempRow = {
          _id: `temp-${Date.now()}-${file.name}`, // temporary id
          fileName: file.name,
          addedByName: this.$store.state.user.profile.fullName,
          cDate: {
            date: new Date().toLocaleDateString(),
            time: new Date().toLocaleTimeString()
          },
          statusIndex: 0, // In Progress
          statusNote: 'Uploading...',
          uploadedFileUrl: ''
        };
        this.rows.unshift(tempRow);

        try {
          // 2️⃣ Upload file
          const response = await stores.uploadFiles(file);
          let uploadedFileMeta = {};
          try {
            uploadedFileMeta = await response.json();
          } catch {
            uploadedFileMeta = { Key: file.name };
          }
          const key = uploadedFileMeta.Key || file.name;

          // 3️⃣ Save in knowledge DB
          await knowledgeService.createKnowledgeFile({
            addedByName: this.$store.state.user.profile.fullName,
            fileName: key
            // uploadedFileUrl:key,
          });

          this.$q.notify({ message: `Uploaded ${file.name}`, color: 'green' });

          // 4️⃣ Refresh list from server → replaces temp row with real one
          this.fetchFiles();
        } catch (err) {
          console.error(err);

          // Update temp row to "Failed"
          const temp = this.rows.find(r => r._id === tempRow._id);
          if (temp) {
            temp.statusIndex = 2; // Failed
            temp.statusNote = 'Upload failed';
          }

          this.$q.notify({
            message: `Upload failed for ${file.name}`,
            color: 'red'
          });
        }
      }

      event.target.value = null;
    },

    async viewRow(row) {
      this.loading = true;
      try {
        const data = await stores.ApiGetImage(row.fileName);
        const url = data.response.url;
        if (!url) {
          this.$q.notify({ message: 'PDF URL not available', color: 'red' });
          return;
        }

        this.selectedRow = row;

        // Option 1: open in new tab
       window.open(
        `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`,
        '_blank'
      );


        // this.pdfUrl = url;
        // this.showViewDialog = true;
      } catch (err) {
        this.$q.notify({ message: err.message, color: 'red' });
      } finally {
        this.loading = false;
      }
    },

    openPDF(row) {
      if (row && row.uploadedFileUrl) {
        window.open(row.uploadedFileUrl, '_blank');
      } else {
        this.$q.notify({ message: 'PDF URL not available', color: 'red' });
      }
    },
    confirmDeleteRow(row) {
      this.rowToDelete = row;
      this.showDeleteDialog = true;
    },
    cancelDelete() {
      this.rowToDelete = null;
      this.showDeleteDialog = false;
    },
    async performDelete() {
      if (!this.rowToDelete) return;
      try {
        await knowledgeService.deleteKnowledgeFile(this.rowToDelete._id);
        this.$q.notify({
          message: `Deleted ${this.rowToDelete.fileName}`,
          color: 'red'
        });
        this.fetchFiles();
      } catch (err) {
        console.error(err);
        this.$q.notify({
          message: `Failed to delete ${this.rowToDelete.fileName}`,
          color: 'red'
        });
      } finally {
        this.cancelDelete();
      }
    }
  }
};
